import React from "react";
import { Button, Box } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";

const YetkisizErisim = ({ sayfaAdi }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          background: "rgba(255,255,255,0.65)",
          backdropFilter: "blur(8px)",
          borderRadius: "20px",
          padding: "40px 50px",
          maxWidth: 520,
          textAlign: "center",
          border: "1px solid rgba(184,134,11,0.4)",
          boxShadow: "0 12px 35px rgba(0,0,0,0.15)",
        }}
      >
        <LockOutlinedIcon
          sx={{
            fontSize: 70,
            color: "#b8860b",
            mb: 2,
          }}
        />

        <h2 style={{ color: "#8b6508", marginBottom: 10 }}>
          Yetkisiz Erişim
        </h2>

        <p
          style={{
            color: "#444",
            fontSize: "1rem",
            lineHeight: 1.6,
            marginBottom: 25,
          }}
        >
          Bu sayfayı görüntülemek için
          gerekli yetkiye sahip değilsiniz.
          <br />
          Lütfen firma yöneticiniz ile iletişime geçiniz.
        </p>

        <Button
          variant="contained"
          onClick={() => navigate("/kuyumcu")}
          sx={{
            background: "#b8860b",
            color: "#fff",
            fontWeight: "bold",
            textTransform: "none",
            paddingX: 4,
            paddingY: 1.2,
            borderRadius: "30px",
            "&:hover": {
              background: "#a07408",
            },
          }}
        >
          Ana Sayfaya Dön
        </Button>
      </Box>
    </Box>
  );
};

export default YetkisizErisim;
